import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, PreSOJobsMutations } from './types';
import Vue from 'vue';
const _mutations = namespaceHelper.removeNamespace(namespace, PreSOJobsMutations);

export default {
  [_mutations.SET_PRE_SO_JOBS_COUNT](state, count) {
    state.preSOJobCount = count;
  },
  [_mutations.SET_PRE_SO_JOBS](state, preSOJobs) {
    state.preSOJobs = preSOJobs;
  },
  [_mutations.SET_JOB_FOR_ASSIGNMENT](state, jobForAssignment) {
    state.jobForAssignment = jobForAssignment;
  },
  [_mutations.SET_JOB_FOR_ASSIGNMENT_PROPERTY](state, { property, value }) {
    if (state.jobForAssignment) {
      Vue.set(state.jobForAssignment, property, value);
    }
  },
  [_mutations.SET_UNIT_PRE_SO_JOBS](state, unitPreSOJobs) {
    unitPreSOJobs.forEach(job => (job.isSelected = false));
    var jobForAssignment = state.jobForAssignment;
    if (jobForAssignment) {
      const matchingJob = unitPreSOJobs.find(job => job.id === jobForAssignment.id);
      if (matchingJob) {
        matchingJob.isSelected = true;
        matchingJob.isToExistingSO = jobForAssignment.isToExistingSO;
        matchingJob.isToNewSO = jobForAssignment.isToNewSO;
        matchingJob.serviceTrucks = jobForAssignment.serviceTrucks;
        matchingJob.licensePlate = jobForAssignment.licensePlate;
      }
      state.jobForAssignment = {};
    }
    state.unitPreSOJobs = unitPreSOJobs;
  },
  [_mutations.SET_JOB_PROPERTY](state, { id, property, value }) {
    const job = state.unitPreSOJobs.find(j => j.id === id);
    if (job) {
      Vue.set(job, property, value);
    }
  },
  [_mutations.SET_SHOW_PRE_SO_JOBS](state, showPreSOJobs) {
    state.showPreSOJobs = showPreSOJobs;
  },
  [_mutations.UPDATE_PRE_SO_JOB_VIN](state, updatedJob) {
    const jobIndex = state.preSOJobs.findIndex(j => j.id === updatedJob.id);
    if (jobIndex !== -1) {
      const mergedJob = {
        ...state.preSOJobs[jobIndex],
        ...updatedJob
      };
      Vue.set(state.preSOJobs, jobIndex, mergedJob);
    }
  }
};
